import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { userColumns } from "./datatablesource";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  collection,
  query,
  orderBy,
  limit,
  getDocs,
  startAfter,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { db } from "../../firebase";

const Datatable = () => {
  const [data, setData] = useState([]);
  const [lastDoc, setLastDoc] = useState(null); // Track last document for pagination
  const [loading, setLoading] = useState(false);

  // Fetch initial 10 documents ordered by timestamp
  const fetchData = async () => {
    setLoading(true);
    const paymentsRef = collection(db, "payments");
    
    // Query to get documents ordered by timestamp in descending order
    const q = query(paymentsRef, orderBy("timestamp", "desc"), limit(10));

    const snapshot = await getDocs(q);
    let list = [];
    snapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });

    setData(list);
    setLastDoc(snapshot.docs[snapshot.docs.length - 1]); // Store last document for pagination
    setLoading(false);
  };

  // Fetch more documents (next 10)
  const fetchMoreData = async () => {
    if (!lastDoc) return; // No more data to load
    setLoading(true);
    const paymentsRef = collection(db, "payments");
    
    // Query for the next batch, starting after the last document
    const q = query(paymentsRef, orderBy("timestamp", "desc"), startAfter(lastDoc), limit(10));

    const snapshot = await getDocs(q);
    let list = [];
    snapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });

    setData((prevData) => [...prevData, ...list]); // Append new data to the existing list
    setLastDoc(snapshot.docs[snapshot.docs.length - 1]); // Update the last document for pagination
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "payments", id));
      setData(data.filter((item) => item.id !== id));
    } catch (err) {
      console.log(err);
    }
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/transaction/fullview?uid=${params.row.id}`}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">View</div>
            </Link>
            <div
              className="deleteButton"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="datatable">
      <DataGrid
        className="datagrid"
        rows={data}
        columns={userColumns.concat(actionColumn)}
        pageSize={10}
        rowsPerPageOptions={[10]}
        checkboxSelection
      />
      {!loading && lastDoc && (
        <button onClick={fetchMoreData} className="loadMoreButton">
          Load More
        </button>
      )}
      {loading && <p>Loading...</p>}
    </div>
  );
};

export default Datatable;
